(function($) {
	// Get Window Width and Height
	var windowWidth = $(window).outerWidth();
	var windowHeight = $(window).height();
	var documentHeight = $(document).height();

	var didScroll;
	var lastScrollTop = 0;
	var delta = 5;
	var navbarHeight = 120;

	$(window).scroll(function(event){
	    didScroll = true;
	});

	setInterval(function() {
	    if (didScroll) {
	        hasScrolled();
	        didScroll = false;
	    }
	}, 250);

	// Dölj den lilla loggan i fasta headern innan den stora vimpel-loggan kommer in i bild
	function toggleLargeLogoInView(st) {
		var largeLogo = $('.large-logo');
		if (!largeLogo.is(':visible')) {
			$('html').removeClass('large-logo-in-view');
			return;
		}
		var largeLogoBottom = largeLogo.offset().top + largeLogo.outerHeight();
		$('html').toggleClass('large-logo-in-view', st < largeLogoBottom + 50);
	}

	function hasScrolled() {
	    var st = $(this).scrollTop();
	    toggleLargeLogoInView(st);
	    // Make sure they scroll more than delta
	    if(Math.abs(lastScrollTop - st) <= delta)
	        return;

	    // If they scrolled down and are past the navbar, add class .nav-up.
	    // This is necessary so you never see what is "behind" the navbar.
	    if (st > lastScrollTop && st > navbarHeight){
	        // Scroll Down
					$('html').addClass('scrolled');
					$('html').removeClass('visible');
	    } else {
	        // Scroll Up
	        if (st < getCollapseHeight()) {
						collapseHeader();
	        } else if(st < lastScrollTop) {
						clearTimeout(collapseTimer);
						$('html').addClass('scrolled');
						$('html').addClass('visible');
	        }
	    }
	    lastScrollTop = st;
	}

	// Fasta naven fälls upp vid halva heron (eller navbarHeight om sidan saknar hero)
	function getCollapseHeight() {
		var hero = $('.images').first();
		if (!hero.length) return navbarHeight;
		return Math.max(navbarHeight, hero.offset().top + hero.outerHeight() / 2);
	}

	// Låt naven glida upp först och släpp sedan .scrolled, så headern inte hoppar
	var collapseTimer;
	function collapseHeader() {
		if (!$('html').hasClass('scrolled')) return;
		$('html').removeClass('visible');
		clearTimeout(collapseTimer);
		collapseTimer = setTimeout(function() {
			if (!$('html').hasClass('visible')) {
				$('html').removeClass('scrolled');
			}
		}, 300);
	}


	// Startsidans hero: avstånd från sidans topp till heron, används för fullhöjd minus header
	function setHeroOffset() {
		var hero = $('.home .images').first();
		if (!hero.length) return;
		document.documentElement.style.setProperty('--hero-offset', hero.offset().top + 'px');
	}


	/* Document ready functions */
	$(document).ready(function (){

		setHeroOffset();

	});

	$(window).on('load', setHeroOffset);

	$(window).resize(function () {

		setHeroOffset();

	});

})(jQuery);
